var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 108,
    viewBox: "0 0 122 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L60.8286 108L121.5 0H0ZM30.4931 17.9911L50.5308 18.0235L60.7763 36.0899L71.0215 18.0235L91.0595 17.9911L60.8286 71.8564H60.7237L30.4931 17.9911Z",
    fill: "url(#paint0_linear_80_664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_664",
    x1: 60.75,
    y1: 0,
    x2: 60.75,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63CDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVBlue);
export default __webpack_public_path__ + "static/media/V-blue.3232b9cde61d7782f4a9b5608431866c.svg";
export { ForwardRef as ReactComponent };